// src/features/time-analysis/components/TimeAnalysisSummary.jsx
'use client';

import { ChecksIcon, Atom, Flask, Calculator } from '@phosphor-icons/react';
import StatCell from '../generic/StatCell';
import { secondsToMinutes } from '../../../../../apps/frontend/src/utils/utilFunctions';
import TableHeader from '../../components/generic/TableHeader';
import { QSTATUS } from '../../../../../apps/frontend/src/utils/strings';
// import PackLoader from "../generic/PackLoader"
import TimeAnalysisSkeleton from './TimeAnalysisHourSkeleton';
import NoData from '../generic/NoData';

const TimeAnalysisSummary = ({ data, loading, onResetFilters }) => {
  if (loading) return <TimeAnalysisSkeleton />;

  if (!data || data.length === 0) return <NoData onResetAll={onResetFilters} />;

  const icons = {
    Overall: ChecksIcon,
    Physics: Atom,
    Chemistry: Flask,
    Mathematics: Calculator,
  };

  console.log('TimeAnalysisSummary data:', data);

  return (
    <div>
      <TableHeader headerTitle="Summary">
        {/* Added horizontal scroll container */}
        <div className="overflow-x-auto">
          <div className="min-w-[600px] border border-[var(--q3-stroke-light)] rounded-b-lg overflow-hidden">
            {/* Table Head */}
            <div className="bg-[var(--q3-surface-dim)] border-b border-[var(--q3-stroke-light)]">
              <div className="grid grid-cols-4 divide-x divide-[var(--q3-stroke-light)] text-sm font-medium text-[var(--q3-neutral-default)]">
                <div className="p-4">Subject</div>
                <div className="p-4 text-center text-[var(--q3-green-normal)]">Correct Qs Time</div>
                <div className="p-4 text-center text-[var(--q3-danger-normal)]">Incorrect Qs Time</div>
                <div className="p-4 text-center text-[var(--q3-neutral-light)]">Not Attempted Qs Time</div>
              </div>
            </div>

            {/* Table Body */}
            {data.map((row, index) => {
              const iconUrl = row.subjectMeta?.icon;

              return (
                <div key={index} className="border-b border-[var(--q3-stroke-light)] last:border-b-0">
                  <div className="grid grid-cols-4 divide-x divide-[var(--q3-stroke-light)] text-sm text-[var(--q3-neutral-default)]">
                    {/* Subject Cell - Made more compact */}
                    <div className="p-3 flex items-center gap-2">
                      {iconUrl ? (
                        <img
                          src={iconUrl}
                          alt={row.subjectMeta?.title || 'Subject Icon'}
                          className="w-[18px] h-[18px] object-contain min-w-[18px]"
                        />
                      ) : (
                        <CheckCircle size={18} className="text-[var(--q3-neutral-default)] min-w-[18px]" />
                      )}
                      <span className="font-medium text-[var(--q3-neutral-default)] truncate">
                        {row.subjectMeta?.title}
                      </span>
                    </div>

                    {/* Correct Qs Time */}
                    <div className="text-center text-green-600 ">
                      <StatCell
                        color="green"
                        top={row.correct}
                        bottom={row.totalTimeSpent}
                        showPercentage={true}
                        themedText={true}
                        compact={true}
                        {...QSTATUS.CORRECT}
                      />
                    </div>

                    {/* Incorrect Qs Time */}
                    <div className="text-center text-red-600 ">
                      <StatCell
                        color="red"
                        top={row.inCorrect}
                        bottom={row.totalTimeSpent}
                        showPercentage={true}
                        themedText={true}
                        compact={true}
                        {...QSTATUS.INCORRECT}
                      />
                    </div>

                    {/* Not Attempted Qs Time */}
                    <div className="text-center text-gray-600 ">
                      <StatCell
                        color="gray"
                        top={row.notAnswered}
                        bottom={row.totalTimeSpent}
                        showPercentage={true}
                        themedText={true}
                        compact={true}
                        {...QSTATUS.NOT_ATTEMPTED}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </TableHeader>
    </div>
  );
};

export default TimeAnalysisSummary;
